module.exports = __webpack_public_path__ + "static/media/September2021Newsletter.89f92fae.pdf";